import { render, staticRenderFns } from "./GroupRow.vue?vue&type=template&id=54f01cec"
import script from "./GroupRow.vue?vue&type=script&lang=ts"
export * from "./GroupRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports